import React, {useState} from 'react';
import NavButton from './NavButton';
import {useUserClient} from "../../../react-hooks/useUserClient";
import {useAureliaI18n} from "../../../react-hooks/useAureliaI18n";

const Permissions = () => {

    const { t } = useAureliaI18n();
    const [userClient, hasRole] = useUserClient();
    const [showWithoutPermission, setShowWithoutPermission] = useState(userClient?.showWithoutPermission);
    const [loading, setLoading] = useState(false);

    const modify = (value) => {

        if (loading) {
            return;
        }

        setLoading(true);

        userClient.setShowWithoutPermission(value).then(() => {

            setShowWithoutPermission(value);
            setLoading(false);

        }, (error) => {
            setLoading(false);
        });
    };

    return showWithoutPermission ? (
        <NavButton
            title={t('permission.hideWithoutPermission')}
            onClick={() => modify(false)}
        >
      <span>
        <i className={`fa fa-user-check fa-sm`}></i>
      </span>
        </NavButton>
    ) : (
        <NavButton
            title={t('permission.showWithoutPermission')}
            onClick={() => modify(true)}
        >
      <span>
        <i className={`fa fa-user-slash fa-sm`}></i>
      </span>
        </NavButton>
    );
};

export default Permissions;
